
import React, { lazy, useEffect, useRef, useState } from "react";
import SectionSkeleton from "./sectionskeleton";
import LazySection from "components/lazySection";
import CommBanner from "components/Community-Development/communityDevelopBanner";
import CommDevelDetail from "components/Community-Development/communityDevelopmentDetail";

const CommunityDetailPage: React.FC = () => {

  return (
    <>
     <CommBanner /> 
        <LazySection fallback={<SectionSkeleton height={300} />}>
        <CommDevelDetail />
      </LazySection> 
    </>
  );
};

export default CommunityDetailPage;
